import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchDuplicateGroups } from "../api/titleMergeService";
export var useDuplicateGroups = function (titleId) {
    var kyInstance = useOkapiKy();
    // The detail must paint first; the duplicate lookup scans identifiers and can wait a tick.
    var _a = useState(false), deferred = _a[0], setDeferred = _a[1];
    useEffect(function () {
        setDeferred(false);
        if (!titleId)
            return undefined;
        var handle = window.setTimeout(function () { return setDeferred(true); }, 0);
        return function () { return window.clearTimeout(handle); };
    }, [titleId]);
    var _b = useQuery(["title-duplicate-groups", titleId], function () { return fetchDuplicateGroups(kyInstance, titleId); }, { enabled: deferred && !!titleId, staleTime: 30000 }), _c = _b.data, groups = _c === void 0 ? [] : _c, isLoading = _b.isLoading, isError = _b.isError;
    return { groups: groups, isGroupsLoading: isLoading, isGroupsError: isError };
};
